import { render, staticRenderFns } from "./ViewModal.vue?vue&type=template&id=47875c2c&scoped=true&"
import script from "./ViewModal.vue?vue&type=script&lang=ts&"
export * from "./ViewModal.vue?vue&type=script&lang=ts&"
import style0 from "./ViewModal.vue?vue&type=style&index=0&id=47875c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47875c2c",
  null
  
)

export default component.exports